
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AlertBox extends Vue {
  @Prop({ default: 'mdi-alert' }) icon!: string;
  @Prop({ default: '' }) message!: string;
}
